import { apiAxios } from '../../../helpers'

export const getList = async (commit, idTournament, idPhase) => {
  const result = await apiAxios.get('tournaments/' + idTournament + '/phases/' + idPhase + '/groups')
  commit('updateList', result.data.data.groups)
}

export const getOne = async (commit, idTournament, idPhase, idGroup) => {
  const result = await apiAxios.get('tournaments/' + idTournament + '/phases/' + idPhase + '/groups/' + idGroup)
  commit('updateOne', result.data.data.group)
}
